import { createFileRoute } from "@tanstack/react-router"
import { RequestResetPassword } from "@/app"

export const Route = createFileRoute("/(public)/auth/reset-password/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <RequestResetPassword />
}
